import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { trackingDirective } from '@/services/analytics-service'
import '@/services/i18n'
import { i18nService, callEctApi, analyticsFactory } from '@accor/customer-vue-services'
import { createMetaManager } from 'vue-meta'
import '@/styles/mains.scss'
import '@/stores'
import { configureEnv } from '@/services/env'
import { useOrderStore } from '@/stores/orders'
import { useUserStore } from '@/stores/user'
import Vue3Lottie from 'vue3-lottie'
import '@accor/ah-navigation/src/scss/main.scss'
import { env } from '@accor/customer-core'
import { axiosApi } from '@/services/http/axiosApi'
import axiosSecure from '@/services/http/axiosSecure'
import TagManager from '@accor/core-services/src/gtm'
import { CurrencyService } from '@accor/core-services/src/currency'
import * as customerApiServices from '@accor/customer-api/cloud'
import { all } from '@accor/ads-theme/presets'
import { Ads } from '@accor/ads-components'

//Quich and dirty fix to keep a reference to __VUE_HMR_RUNTIME__ from Vue 3 before it's overriden by Vue 2.
//It will be restored in App.vue on the onMounted hook.
window.__VUE_HMR_RUNTIME__BACKUP = window.__VUE_HMR_RUNTIME__

export const app3 = createApp(App)

const init = async () => {
  await configureEnv()

  i18nService.enableFilterAllAccorComByEnv()
  callEctApi()

  app3.use(Ads, {
    theme: {
      preset: all,
      mode: 'light'
    }
  })
  app3.use(i18nService.i18n)
  app3.use(createPinia())
  app3.use(router)
  app3.use(createMetaManager())
  app3.directive('gtm', trackingDirective)
  app3.use(Vue3Lottie)

  // todo Expose stores in windows for app2 to use. To delete once the dependency is removed
  window.useOrderStore = useOrderStore
  window.useUserStore = useUserStore
  window.vueServices = {
    axiosApi,
    axiosSecure,
    env,
    i18nService,
    coreServices: {
      TagManager,
      CurrencyService
    },
    analyticsFactory,
    customerApiServices
  }

  app3.mount('#app3')
}

window.vue3ReadyPromise = init()
